import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	sideBarPanelSplitterLabel: {
		id: 'navigation-apps-sidebar-nav4-sidebar-selector.side-bar-panel-splitter-label',
		defaultMessage: 'Resize side navigation panel',
		description: 'Button label for resizing the side navigation panel',
	},
});
